import { render } from "./Difunde.vue?vue&type=template&id=900403ba&scoped=true"
const script = {}

import "./Difunde.vue?vue&type=style&index=0&id=900403ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900403ba"]])

export default __exports__